import { render, staticRenderFns } from "./device_logs_page.vue?vue&type=template&id=499bbff1&scoped=true"
import script from "./device_logs_page.vue?vue&type=script&lang=js"
export * from "./device_logs_page.vue?vue&type=script&lang=js"
import style0 from "./device_logs_page.vue?vue&type=style&index=0&id=499bbff1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bbff1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499bbff1')) {
      api.createRecord('499bbff1', component.options)
    } else {
      api.reload('499bbff1', component.options)
    }
    module.hot.accept("./device_logs_page.vue?vue&type=template&id=499bbff1&scoped=true", function () {
      api.rerender('499bbff1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_logs_page.vue"
export default component.exports